
import Vue, { PropType } from "vue";
import { Company } from "@/models";

import BaseInputForm from "@/components/BaseInputForm.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseChuiGaki from "@/components/BaseChuiGaki.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";

export type DataType = {
  name: string;
  zipCode: string;
  address: string;
  facilityName: string;
};

export default Vue.extend({
  name: "CompanyEditor",

  components: {
    BaseInputForm,
    BaseSubmitButton,
    BaseChuiGaki,
    BaseCancelButton,
  },

  props: {
    company: Object as PropType<Company>,
  },

  data(): DataType {
    return {
      name: "",
      zipCode: "",
      address: "",
      facilityName: "",
    };
  },

  computed: {
    isEdited(): boolean {
      return (
        this.company.name !== this.name ||
        this.company.zipCode !== this.zipCode ||
        this.company.address !== this.address ||
        this.company.facilityName !== this.facilityName
      );
    },

    canSubmit(): boolean {
      return !!this.name && !!this.zipCode && !!this.address && !!this.facilityName && (!this.company || this.isEdited);
    },
  },

  watch: {
    company: function(n: Company) {
      this.name = n.name || "";
      this.zipCode = n.zipCode || "";
      this.address = n.address || "";
      this.facilityName = n.facilityName || "";
    },
  },

  methods: {
    saveCompany(): void {
      if (!this.canSubmit) {
        return;
      }

      this.$emit(
        "save-company",
        new Company({
          name: this.name,
          zipCode: this.zipCode,
          address: this.address,
          facilityName: this.facilityName,
        }),
      );
    },
  },
});
